(function() {
  'use strict';

  function formatMoney(cents) {
    return '₹' + Math.round(cents/100).toLocaleString('en-IN');
  }

  window.showToast = function(msg, type = 'success') {
    const toast = document.createElement('div');
    toast.className = 'toast ' + type;
    toast.innerText = msg;
    document.body.appendChild(toast);
    
    // Inline styling for toast since it might not be in theme.css
    toast.style.position = 'fixed';
    toast.style.bottom = '20px';
    toast.style.left = '50%';
    toast.style.transform = 'translateX(-50%)';
    toast.style.background = type === 'error' ? '#ef4444' : '#10b981';
    toast.style.color = '#fff';
    toast.style.padding = '12px 24px';
    toast.style.borderRadius = '8px';
    toast.style.zIndex = '9999';
    toast.style.boxShadow = '0 4px 6px -1px rgba(0,0,0,0.1)';
    toast.style.transition = 'opacity 0.3s ease';

    setTimeout(() => {
      toast.style.opacity = '0';
      setTimeout(() => toast.remove(), 300);
    }, 2500);
  };

  const SexuloonCart = {
    fetchCart: function() {
      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          this.updateCartCount(cart.item_count);
          this.renderCartItems(cart);
        })
        .catch(err => console.error('Error fetching cart:', err));
    },
    updateCartCount: function(count) {
      const countEl = document.getElementById('cart-count');
      const drawerCountEl = document.getElementById('cart-drawer-count');
      if (countEl) countEl.innerText = count;
      if (drawerCountEl) drawerCountEl.innerText = count + ' Items';
    },
    renderCartItems: function(cart) {
      const container = document.getElementById('cart-items-container');
      const footer = document.getElementById('cart-footer');
      const subtotalEl = document.getElementById('cart-subtotal-price');
      const subtotalCompareEl = document.getElementById('cart-subtotal-compare');
      const savingsEl = document.getElementById('cart-total-savings');
      const upsellContainer = document.getElementById('cart-upsell-container');
      
      if (!container) return;
      container.innerHTML = '';
      
      if (cart.item_count === 0) {
        container.innerHTML = '<div class="cart-empty-state"><svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" style="margin:0 auto 1rem; color: #94a3b8;"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg><p style="font-weight:600;margin-bottom:1rem;color:#0f172a;">Your cart is empty</p><a href="/collections/all-products" class="btn-checkout" style="display:inline-block;width:auto;padding:0.75rem 2rem;text-decoration:none;text-align:center;">Shop Now</a></div>';
        if (footer) footer.style.display = 'none';
        if (upsellContainer) upsellContainer.style.display = 'none';
        return;
      }
      
      if (footer) footer.style.display = 'block';
      
      let totalCompareAtPrice = 0;
      let cartItemHandles = [];
      
      cart.items.forEach(item => {
        cartItemHandles.push(item.handle);
        // Fallback compare_at_price logic since items might not provide it reliably in cart.js
        let comparePrice = item.properties && item.properties.compare_at_price ? parseInt(item.properties.compare_at_price) : 100000; 
        if (comparePrice < item.price) comparePrice = 100000;
        
        const lineComparePrice = comparePrice * item.quantity;
        totalCompareAtPrice += lineComparePrice;
        
        const discountPercentage = Math.round(((comparePrice - item.price) / comparePrice) * 100);
        
        const itemEl = document.createElement('div');
        itemEl.className = 'cart-item';
        
        itemEl.innerHTML = `
          <button type="button" class="cart-remove-btn" data-key="${item.key}" aria-label="Remove item">
            <svg viewBox="0 0 24 24"><path d="M3 6h18M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2M10 11v6M14 11v6"/></svg>
          </button>
          <img src="${item.image}&width=200" alt="${item.product_title}" class="cart-item-img">
          <div class="cart-item-body">
            <div class="cart-item-name">${item.product_title}</div>
            <div class="cart-item-prices">
              <span class="cart-item-price">${formatMoney(item.price)}</span>
              ${comparePrice > item.price ? `<span class="cart-item-compare">${formatMoney(comparePrice)}</span><span class="cart-item-discount">(${discountPercentage}% OFF)</span>` : ''}
            </div>
            <div class="cart-item-controls">
              <div class="qty-control">
                <button type="button" class="qty-btn cart-qty-btn" data-key="${item.key}" data-qty="${item.quantity - 1}">-</button>
                <div class="qty-num">${item.quantity}</div>
                <button type="button" class="qty-btn cart-qty-btn" data-key="${item.key}" data-qty="${item.quantity + 1}">+</button>
              </div>
            </div>
          </div>
        `;
        container.appendChild(itemEl);
      });
      
      if (subtotalEl) subtotalEl.innerText = formatMoney(cart.total_price);
      if (subtotalCompareEl) subtotalCompareEl.innerText = formatMoney(totalCompareAtPrice);
      
      const totalSavings = totalCompareAtPrice - cart.total_price;
      if (savingsEl) {
        if (totalSavings > 0) {
          savingsEl.innerText = `You save ${formatMoney(totalSavings)}`;
          savingsEl.style.display = 'block';
          if(subtotalCompareEl) subtotalCompareEl.style.display = 'inline';
        } else {
          savingsEl.style.display = 'none';
          if(subtotalCompareEl) subtotalCompareEl.style.display = 'none';
        }
      }
      
      container.querySelectorAll('.cart-qty-btn').forEach(btn => {
        btn.addEventListener('click', (e) => {
          const key = e.currentTarget.dataset.key;
          const qty = e.currentTarget.dataset.qty;
          this.changeQuantity(key, qty);
        });
      });
      
      container.querySelectorAll('.cart-remove-btn').forEach(btn => {
        btn.addEventListener('click', (e) => {
          const key = e.currentTarget.closest('.cart-remove-btn').dataset.key;
          this.changeQuantity(key, 0);
        });
      });

      this.renderUpsell(cartItemHandles);
    },
    renderUpsell: function(cartHandles) {
      const upsellContainer = document.getElementById('cart-upsell-container');
      const upsellScroll = document.getElementById('cart-upsell-scroll');
      if (!upsellContainer || !upsellScroll) return;
      
      fetch('/products.json?limit=6')
        .then(res => res.json())
        .then(data => {
          const products = data.products.filter(p => !cartHandles.includes(p.handle)).slice(0, 4);
          if (products.length === 0) {
            upsellContainer.style.display = 'none';
            return;
          }
          upsellContainer.style.display = 'block';
          upsellScroll.innerHTML = '';
          
          products.forEach(p => {
            const priceCents = p.variants[0].price * 100;
            const imgSrc = p.images && p.images[0] ? p.images[0].src : '';
            
            const card = document.createElement('div');
            card.className = 'upsell-card';
            card.innerHTML = `
              <img src="${imgSrc}&width=200" alt="${p.title}" class="upsell-img">
              <div class="upsell-name">${p.title}</div>
              <div class="upsell-price">${formatMoney(priceCents)}</div>
              <button type="button" class="upsell-add-btn" data-id="${p.variants[0].id}">+ Add</button>
            `;
            upsellScroll.appendChild(card);
          });
          
          upsellScroll.querySelectorAll('.upsell-add-btn').forEach(btn => {
            btn.addEventListener('click', (e) => {
              const id = e.currentTarget.dataset.id;
              this.addToCart(id);
            });
          });
        })
        .catch(err => console.error('Error fetching upsell products:', err));
    },
    changeQuantity: function(key, quantity) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: parseInt(quantity) })
      })
      .then(res => res.json())
      .then(() => {
        this.fetchCart();
      })
      .catch(err => console.error('Error changing quantity:', err));
    },
    addToCart: function(variantId) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(res => res.json())
      .then(() => {
        this.fetchCart();
        this.openCart();
        window.showToast('Added to cart');
      })
      .catch(err => {
        console.error('Error adding to cart:', err);
        window.showToast('Error adding to cart', 'error');
      });
    },
    openCart: function() {
      const drawer = document.getElementById('cart-drawer');
      const overlay = document.getElementById('cart-overlay');
      if (drawer) drawer.classList.add('open');
      if (overlay) overlay.classList.add('open');
      document.body.style.overflow = 'hidden';
    },
    closeCart: function() {
      const drawer = document.getElementById('cart-drawer');
      const overlay = document.getElementById('cart-overlay');
      if (drawer) drawer.classList.remove('open');
      if (overlay) overlay.classList.remove('open');
      document.body.style.overflow = '';
    }
  };
  
  window.SexuloonCart = SexuloonCart;

  document.addEventListener('DOMContentLoaded', () => {
    const siteHeader = document.getElementById('site-header');
    if (siteHeader) {
      window.addEventListener('scroll', () => {
        if (window.scrollY > 10) {
          siteHeader.classList.add('scrolled');
        } else {
          siteHeader.classList.remove('scrolled');
        }
      });
    }

    const hamburger = document.getElementById('hamburger-btn');
    const mobileNav = document.getElementById('mobile-nav');
    if (hamburger && mobileNav) {
      hamburger.addEventListener('click', () => {
        mobileNav.classList.toggle('open');
      });
    }
    
    const mobileMoreToggle = document.getElementById('mobile-more-toggle');
    const mobileSubLinks = document.getElementById('mobile-sub-links');
    if (mobileMoreToggle && mobileSubLinks) {
      mobileMoreToggle.addEventListener('click', () => {
        mobileSubLinks.classList.toggle('open');
      });
    }

    SexuloonCart.fetchCart();

    document.addEventListener('click', (e) => {
      const atcBtn = e.target.closest('[data-add-to-cart]');
      if (atcBtn) {
        e.preventDefault();
        const variantId = atcBtn.dataset.variantId;
        if (variantId) {
          SexuloonCart.addToCart(variantId);
        }
      }

      if (e.target.closest('#cart-open-btn') || e.target.closest('[data-open-cart]')) {
        e.preventDefault();
        SexuloonCart.openCart();
      }

      if (e.target.closest('#cart-close-btn') || e.target.closest('#cart-overlay')) {
        SexuloonCart.closeCart();
      }

      // Checkout button — now handled by Razorpay Magic Checkout via form submit interception
      // If Magic Checkout is inactive, the form naturally submits to /checkout

      const footerAccBtn = e.target.closest('.footer-acc-btn');
      if (footerAccBtn) {
        footerAccBtn.classList.toggle('open');
        const content = footerAccBtn.nextElementSibling;
        if (content && content.classList.contains('footer-acc-content')) {
          content.classList.toggle('open');
        }
      }

      const faqQ = e.target.closest('.faq-q');
      if (faqQ) {
        const wasOpen = faqQ.classList.contains('open');
        
        document.querySelectorAll('.faq-q.open').forEach(el => {
          el.classList.remove('open');
          if (el.nextElementSibling) el.nextElementSibling.classList.remove('open');
        });

        if (!wasOpen) {
          faqQ.classList.add('open');
          const content = faqQ.nextElementSibling;
          if (content && content.classList.contains('faq-a')) {
            content.classList.add('open');
          }
        }
      }
    });
  });

  // ─── GoKwik Checkout ─────────────────────────────────────────────
  // Triggers GoKwik checkout if SDK is present; falls back to Shopify /checkout
  async function goKwikCheckout() {
    // Attempt GoKwik SDK checkout trigger
    if (window.gokwikSdk) {
      try {
        window.gokwikSdk.checkout();
        return;
      } catch(e) { /* fall through */ }
    }

    // Attempt GoKwik via kwikCheckout global
    if (window.kwikCheckout && typeof window.kwikCheckout.openCheckout === 'function') {
      try {
        window.kwikCheckout.openCheckout();
        return;
      } catch(e) { /* fall through */ }
    }

    // Attempt via KwikPass SDK triggerCheckout
    if (window.__KP_LOGIN_SDK_INSTANCE__ && typeof window.__KP_LOGIN_SDK_INSTANCE__.triggerCheckout === 'function') {
      try {
        window.__KP_LOGIN_SDK_INSTANCE__.triggerCheckout();
        return;
      } catch(e) { /* fall through */ }
    }

    // Fallback: Get Shopify cart token and redirect
    try {
      const cartRes = await fetch('/cart.js');
      const cartData = await cartRes.json();
      const token = cartData.token;
      if (token) {
        // Fire GoKwik checkout event before redirect
        window.dispatchEvent(new CustomEvent('gk:checkout', {
          detail: { cartToken: token, merchantId: '3zdztimqshbg2c' }
        }));
      }
    } catch(e) { /* ignore */ }

    // Final fallback: native Shopify checkout
    window.location.href = '/checkout';
  }

  // ─── KwikPass + Auth Navbar Awareness ────────────────────────────
  // Multi-strategy detection: postMessage (cross-origin), Shopify /account.js,
  // GoKwik localStorage, SSO container mutations, and SDK events.
  // NOTE: GoKwik cookies live on pdp.gokwik.co — not readable here.
  // postMessage is the only cross-domain signal we can receive.

  function updateNavToLoggedIn(accountUrl, displayName) {
    var url = accountUrl || '/pages/kp_account';
    var name = displayName || 'Account';

    // Desktop: swap Sign In + Sign Up → Account + Logout
    var signIn  = document.getElementById('nav-signin-fallback');
    var signUp  = document.getElementById('nav-signup-fallback');
    if (signIn) { signIn.textContent = name; signIn.href = url; }
    if (signUp) { signUp.textContent = 'Logout'; signUp.href = '/pages/kp_account'; signUp.className = 'btn-signin'; }

    // Mobile
    var mob = document.getElementById('mobile-auth-fallback');
    if (mob) {
      mob.innerHTML =
        '<a href="' + url + '" class="mobile-btn mobile-btn-outline">Account</a>' +
        '<a href="/pages/kp_account" class="mobile-btn mobile-btn-filled">Logout</a>';
    }
  }

  // Strategy 0: postMessage from GoKwik iframe (pdp.gokwik.co → our domain)
  // GoKwik's widget runs in the parent page context but may postMessage login events
  window.addEventListener('message', function(event) {
    try {
      if (!event.origin || event.origin.indexOf('gokwik.co') === -1) return;
      var data = event.data || {};
      // Try parsed JSON if string
      if (typeof data === 'string') { try { data = JSON.parse(data); } catch(e) { return; } }
      // Detect login signal from any known GoKwik message format
      var isLogin = data.type === 'kp:login'
        || data.type === 'kp_login'
        || data.type === 'kwikpass_login'
        || data.event === 'login'
        || data.loggedIn === true
        || data.logged_in === true
        || (data.user && data.user.phone)
        || (data.userData && data.userData.phone);
      if (isLogin) {
        var user = data.user || data.userData || {};
        var name = user.name || user.firstName || user.phone || data.phone || 'Account';
        updateNavToLoggedIn('/pages/kp_account', name);
      }
    } catch(e) {}
  });

  // Strategy 1: Check Shopify native customer via meta tag or liquid-injected data
  // NOTE: /account.js fetch removed — Shopify now redirects it cross-origin causing CORS errors
  function checkShopifyCustomer() {
    // No-op: rely on other strategies (localStorage, SSO container, SDK events)
  }

  // Strategy 2: Check GoKwik / KwikPass common localStorage keys
  function checkGoKwikStorage() {
    var keys = [
      'kp_user', 'kpUser', 'kwikpass_user', 'gk_user', 'kpUserData',
      'kwikpassData', 'gokwik_user', 'kpToken', 'kwikpass_token',
      'gkToken', 'gk-kp-token', 'kpLoggedIn'
    ];
    for (var i = 0; i < keys.length; i++) {
      try {
        var val = localStorage.getItem(keys[i]) || sessionStorage.getItem(keys[i]);
        if (val && val !== 'null' && val !== 'undefined' && val !== 'false') {
          var parsed = null;
          try { parsed = JSON.parse(val); } catch(e) {}
          var name = (parsed && (parsed.name || parsed.firstName || parsed.phone)) || 'Account';
          updateNavToLoggedIn('/pages/kp_account', name);
          return true;
        }
      } catch(e) {}
    }
    return false;
  }

  // Strategy 3: Check if #kwikpass-sso-container was populated by GoKwik SDK
  function checkSSOContainer() {
    var container = document.getElementById('kwikpass-sso-container');
    if (container && container.children.length > 0) {
      var signIn = document.getElementById('nav-signin-fallback');
      var signUp = document.getElementById('nav-signup-fallback');
      if (signIn) signIn.style.display = 'none';
      if (signUp) signUp.style.display = 'none';
      var mob = document.getElementById('mobile-auth-fallback');
      var mobileContainer = document.getElementById('kwikpass-sso-container-mobile');
      if (mobileContainer && mobileContainer.children.length > 0 && mob) {
        mob.style.display = 'none';
      }
      return true;
    }
    return false;
  }

  // Strategy 4: Listen for GoKwik SDK login events (all known event names)
  var kpLoginEvents = [
    'kp:logged_in', 'kp-user-login', 'kwikpass:login',
    'gokwik:login', 'kp_login_success', 'kpLoginSuccess',
    'user_login_success', 'kp:user_updated'
  ];
  kpLoginEvents.forEach(function(evtName) {
    window.addEventListener(evtName, function(e) {
      var data = e && e.detail ? e.detail : {};
      var name = data.name || data.phone || data.firstName || 'Account';
      updateNavToLoggedIn('/pages/kp_account', name);
    });
  });

  // Run all checks
  function runAuthChecks() {
    checkShopifyCustomer();
    checkGoKwikStorage();
    checkSSOContainer();
  }

  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runAuthChecks);
  } else {
    runAuthChecks();
  }

  // Re-run after GoKwik SDK loads
  window.addEventListener('kp-script-loaded', function() {
    setTimeout(runAuthChecks, 500);
    setTimeout(runAuthChecks, 1500);
    setTimeout(runAuthChecks, 3000);
  });

  // Watch SSO container for async injection
  if (window.MutationObserver) {
    var kpContainer = document.getElementById('kwikpass-sso-container');
    if (kpContainer) {
      new MutationObserver(checkSSOContainer).observe(kpContainer, { childList: true, subtree: true });
    }
  }

})();
